import React from 'react';
// import './App.css';
import QuoteGenerator from './components/QuoteGenerator';

function App() {
  return (
    <div className="App">
      <QuoteGenerator />
    </div>
  );
}

export default App;
